export default (input) => {
  return input.substr(1)
    .split('&')
    .map(el => el.split('='))
    .reduce((pre, cur) => {
      pre[cur[0]] = cur[1];
      return pre;
    }, {});
};
